import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {Spinner, SpinnerTypes, Text} from 'wix-ui-tpa/cssVars'
import {classes} from './loader.st.css'

export const Loader = () => {
  const {t} = useTranslation()
  const {isMobile} = useEnvironment()

  return (
    <div className={classes.container} aria-labelledby="content" data-hook={DH.SEATINGS_LOADER}>
      <div className={classNames(classes.content, {[classes.desktopContent]: !isMobile})}>
        <div className={classes.text} id="content">
          <Text
            data-hook={DH.MODAL_TITLE}
            tagName="h2"
            className={classNames(classes.title, {[classes.mobileTitle]: isMobile})}
          >
            {t('seatings_loader_title')}
          </Text>
          <Text className={classes.subtitle}>{t('seatings_loader_subtitle')}</Text>
        </div>
        <Spinner type={SpinnerTypes.slim} className={classes.spinner} />
      </div>
    </div>
  )
}
